<template>
    <div id="wrapper">
        <SidebarView :operation="true" :other-payment-receipts="true" :operations-visible="true" />
        <div class="d-flex flex-column" id="content-wrapper">
            <div id="content">
                <TopbarView />

                <div class="container-fluid">
                   
                    <div class="row">
                        <div class="col-12">
                             <b-breadcrumb class="mb-0" :items="items"></b-breadcrumb>
                        </div>
                        <div class="py-3 d-flex flex-row align-items-center justify-content-between">
                            <div class="col-12">
                                <div class="card card-shape home-box">
                                    <div class="card-header d-flex flex-row align-items-center">
                                        <h6 class="m-0 fw-bold text-green">Create Other Receipt & Payment</h6>
                                    </div>
                                    <div class="card-body">
                                        <form class="form" @submit.prevent="submitData">
                                            <other-receipt-payment-form :errors_msg="errors_msg" :errors="errors"
                                                :form="form" :coaSubheadOptions="coaSubheadOptions" :entities="entities"
                                                :acc_error="acc_error" />
                                            <hr />
                                            <div class="text-center py-3">
                                                <SaveButton :isSaving="isSaving" />
                                                <button type="reset" @click="resetForm"
                                                    class="btn akkurate-gray-btn text-white btn-size my-2 ms-3">
                                                    <font-awesome-icon class="me-2" :icon="['fas', 'rotate-right']" />
                                                    Reset
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer></footer>
        </div>

        <!-- AI -->
		 <ChatBot />
		<!-- End AI -->
        <a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
    </div>
</template>


<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import Multiselect from 'vue-multiselect';
import ApiService from "@/core/services/api.service";
import SaveButton from "@/views/main/components/SaveButton.vue";
import OtherReceiptPaymentForm from "../forms/OtherReceiptPaymentForm.vue";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        Multiselect,
        SaveButton,
        OtherReceiptPaymentForm,
        ChatBot,
    },
    data() {
        return {
            ...this.initialState(),
            isSaving: false,
            acc_error: "",
            coaSubheadOptions: [],

            errors: {
                accounts: null,
            },
            errors_msg: "",
            items: [
                {
                    text: 'Other Receipts & Payments',
                    href: '/other-receipt-payment'
                },
                {
                    text: 'Create Other Receipts & Payments',
                    active: true
                }
            ]
        };
    },
    mounted() {
        this.coa_dropdown();
    },
    methods: {
        // addAccount() {
        //     if (this.entities.length < 1) {
        //         this.acc_error = "account can not be lesser then one"
        //         // this.isSaving = true
        //     } else {
        //         this.acc_error = ""
        //         // this.isSaving = false
        //     }
        //     if (this.entities.length > 0) {
        //         this.entities.push({ amount: "", coa_subhead: { id: "", name: "", code: "" } });

        //     }
        // },
        // removeField(index) {
        //     if (this.entities.length == 1) {
        //         this.acc_error = "account can not be lesser then one"
        //         // this.isSaving = true

        //     } else {
        //         this.acc_error = ""
        //         // this.isSaving = false
        //     }
        //     if (this.entities.length > 1) {
        //         this.entities.splice(index, 1);
        //     }
        // },
        // customLabel({ code, name, coabranch }) {
        //     return `${code} - ${name} - ${coabranch?.name ?? ""}`
        // },
        // resetForm() {
        //     this.form = this.initialState().form;
        //     this.entities = [{ amount: "", coa_subhead: { id: "", name: "", code: "" } }];
        //     // this.selectedCoaSubhead = this.initialState().selectedCoaSubhead;
        //     this.errors = [];
        // },
        // entryClicked(event) {
        //     if (event === "RECEIPT_ENTRY") {
        //         this.source = "Source (Debit)";
        //         this.destination = "Destination (Credit)";
        //     } else if (event == "PAYMENT_ENTRY") {
        //         this.source = "Destination (Credit)";
        //         this.destination = "Source (Debit)";
        //     } else {
        //         this.source = "Source (Debit)";
        //         this.destination = "Destination (Credit)";
        //     }
        // },
        coa_dropdown() {
            this.isSaving = true;
            this.$Progress.start();
            ApiService.post("/finance/chart-of-accounts/subhead/dropdown")
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.coaSubheadOptions = response.data.coa_subheads
                })

        },
        resetForm() {
            this.entities = this.initialState().entities;
            this.form = this.initialState().form;
        },
        submitData() {
            this.isSaving = true;
            let form = {
                ...this.form,
                'entities': this.entities
            }
            ApiService.post("other-receipt-payment/store", form)
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.save = "Save";
                    toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    this.errors_msg = {};
                    this.resetForm();
                })
                .catch((error) => {
                    this.isSaving = false;
                    this.$Progress.fail();
                    this.save = "Save";
                    this.resetForm();
                    if (error.response.data) {
                        // Clear previous errors
                        this.errors_msg = {};

                        // Set general message
                        this.errors_msg.message = error.response.data.message;
                        // Set field-specific errors if they exist
                        if (error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach(key => {
                                this.errors_msg[key] = error.response.data.errors[key];
                            });
                        }
                    }
                });
        },

        initialState() {
            return {
                entities: [{ amount: "", coa_subhead: { id: "", name: "", code: "" } }],
                form: {
                    payment_selected: "RECEIPT_ENTRY",
                    trans_date: "",
                },
            }
        }
    }
};

</script>